/**
 * Shared resolver behind uiRevampFlag / navDropdownFlag / dimensionsRevampFlag
 * — they were near-identical copies of this same LD-then-localStorage-then-default
 * logic, one per flag key. (`dashboardRevampFlag` reads LD directly and does
 * not use this helper.)
 *
 * Resolution order:
 *   1. LaunchDarkly — whenever `ldValue` is defined, it wins outright.
 *   2. `localStorage[localStorageKey]` — dev escape hatch, only consulted
 *      when LD has no opinion.
 *   3. `defaultValue`.
 */
const resolveFeatureFlag = (
  localStorageKey: string,
  ldValue: boolean | undefined,
  defaultValue = true,
): boolean => {
  if (ldValue !== undefined) return Boolean(ldValue);

  try {
    const override = window.localStorage.getItem(localStorageKey);
    if (override !== null) return override === 'true';
  } catch {
    // localStorage can throw in private-browsing / sandboxed contexts.
  }

  return defaultValue;
};

export default resolveFeatureFlag;
